export default function WhyUseSection() {
  const cards = [
    {
      icon: 'ri-search-eye-line',
      title: 'Product Discovery',
      desc: 'Access a structured database of products organized by categories, making it effortless to find exactly what you are looking for without endless scrolling through individual listings.',
    },
    {
      icon: 'ri-ship-line',
      title: 'Shipping Research',
      desc: 'Compare shipping rates across multiple carriers, understand delivery timelines, and find the most cost-effective shipping methods for your destination country.',
    },
    {
      icon: 'ri-archive-line',
      title: 'Warehouse Knowledge',
      desc: 'Learn how the warehouse system works including QC inspections, storage timelines, package consolidation, and how to review your QC photos before international shipment.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Buying Safety',
      desc: 'Make informed decisions with verified seller data, community reviews, quality control checklists, and secure payment guidance to protect your purchases.',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-3">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Why Use Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Four powerful reasons why thousands of smart shoppers rely on Basetao Spreadsheet for their purchasing research.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className="group bg-background-50 border border-secondary-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-200 mb-4">
                <i className={`${card.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{card.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}